import { AuthSetUnauthorizedReducer } from './types';

export const authSetUnauthorizedReducer: AuthSetUnauthorizedReducer = (
  state
) => {
  return {
    ...state,
    isAuthorized: false,
    isAdmin: false,
    id: undefined,
    name: undefined,
    email: undefined,
  };
};
